/** True while a modal dialog owns focus; client update waits until it closes. */
export function hasOpenDialog(documentRef: Pick<Document, "querySelector"> = document): boolean {
  return documentRef.querySelector("dialog[open]") !== null;
}
